.fab {
  position: fixed;
  bottom: 70px;
  right: 20px;
  z-index: 1050;
}
